module.exports = __webpack_public_path__ + "img/reject.429b2b73.png";